import { BUSINESS_ADMIN_HOST } from 'api/constants';

export const GET_USER_BY_PHONE_URL = `${BUSINESS_ADMIN_HOST}/v1/users/detail`;
export const RESET_PHONE_NUMBER_URL = `${BUSINESS_ADMIN_HOST}/v1/users/reset-phone-number`;
